import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth-service/auth.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import * as moment from 'moment-timezone';
import { SocketService } from '../socket-service/socket-service.service';
import { SharedDataService } from '../shared-service/shared-data.service';
import { UserRoles } from 'src/app/service/menu-service/menu.service';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';

@Injectable()
export class AuthorizationGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private socket: SocketService,
    private sharedDataService: SharedDataService,
    private router: Router
  ) {
  }

  // @ts-ignore
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUserLogin(next);
  }
  checkUserLogin(route: ActivatedRouteSnapshot) {

    return this.authService.VerifyToken()
      .pipe(
        map((data: any) => {
          if (data.user) {
            const user = data.user;
            const userRole = user.roles && user.roles.length ? user.roles[0] : undefined;
            const routeRoles = route.data && route.data.role ? route.data.role : undefined;
            
            // if user account is deactivated
            if (user.hasOwnProperty('accountStatus') && user.accountStatus === 'inactive') {
              this.socket.disconnectSocket();
              this.authService.removeToken();
              this.sharedDataService.saveUser(null);
              this.router.navigateByUrl('login');
              return false;
            }

            this.socket.connectSocket();
            moment.tz.setDefault(user.company && user.company.timeZone? user.company.timeZone : user.timeZone);
            this.sharedDataService.saveUser(data.user);

            if (!(userRole && routeRoles)) {
              this.logout();
              return false;
            }

            if (userRole === UserRoles.CORPORATE && routeRoles.includes(userRole)) {
              return true;
            } else if (this.isStaff(userRole) && routeRoles.includes(userRole)) {
              return true;
            } else {
              this.router.navigate(['/profile']);
              return false;
            }
          } else {
            this.logout();
            return false;
          }
        }),
        catchError((error) => {
          this.logout();
          return of(false);
        })
      );

  }

  isStaff(userRole) {
    return [UserRoles.FULL_ACCESS, UserRoles.CALL_CENTER_REP, UserRoles.TRANSPORTATION_COORDINATOR].includes(userRole);
  }

  logout() {
    this.sharedDataService.saveUser(null);
    this.socket.disconnectSocket();
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }
}

